import React from "react"
import Skeleton from "@mui/material/Skeleton"

const ActivitySkeleton = ({ className = "" }) => (
  <div data-testid="panel-activity-skeleton" className={`flex items-start gap-3 p-4 ${className}`}>
    <div className="flex-shrink-0 mt-1">
      <Skeleton variant="rounded" width={24} height={24} />
    </div>
    <div className="flex-1 min-w-0">
      <Skeleton variant="text" width="70%" height={20} />
      <Skeleton variant="text" width="50%" height={16} className="mt-1" />
    </div>
    <div className="flex-shrink-0 text-right">
      <Skeleton variant="text" width={50} height={20} />
      <Skeleton variant="text" width={70} height={14} className="mt-1" />
    </div>
  </div>
)

export default ActivitySkeleton
